import React from 'react'

import { Link as GatsbyLink } from 'gatsby'

import { Grid, Typography, Button, Chip, Box } from '@mui/material'
import HeroImage from './HeroImage';

const styles = {
    heroButton: {
        backgroundColor: '#e1f5fe',
        // borderRadius: 0,
        color: "black",
        "&:hover": {
        backgroundColor: '#b3e5fc',
        }
    },
    heroOutlineButton: {
        borderColor: '#e1f5fe',
        // borderRadius: 0,
        color: "#e1f5fe",
        "&:hover": {
            borderColor: '#b3e5fc',
            color: "#b3e5fc",
        }
    }
}

const HeroNew = ({ image, imagePosition = 'center', alt='', tag, soon, to, link, title, subtitle, href1, button1, href2, button2}) => {
    return (
        <div className={'newHero'}>
            <HeroImage
                src={image}
                objectPosition={imagePosition}
                alt={alt}
                loading="eager"
            />
            <div className='newHeroText'>
                { tag && (
                    <Grid container spacing={1} justifyContent='center'>
                        <Grid item>
                            <Typography variant='subtitle1' component='p' textAlign='center' style={{color: 'var(--grey-100)'}}>{tag}</Typography>
                        </Grid>
                    </Grid>
                )}
                { soon && (
                    <Grid container spacing={1} justifyContent='center'>
                        <Box pb={1}>
                            <Chip color='info' label='COMING SOON'/>
                        </Box>
                    </Grid>
                )}
                { link && (
                    <Typography variant='subtitle1' component='p' textAlign='center' style={{color: 'var(--grey-100)'}}><GatsbyLink to={to}>{link}</GatsbyLink></Typography>
                )}
                <Typography variant='h2' component='h1' textAlign='center' sx={{color: 'var(--grey-100)', fontSize:{xs:'42px !important', md:'56px !important', lg:'60px !important', xl:'68px !important'}}}>{title}</Typography>
                <Typography variant='h6' component='p' textAlign='center' sx={{color: 'var(--grey-100)'}}>{subtitle}</Typography>
                { button1 && (
                    <Grid container sx={{ mt:2 }} spacing={1} justifyContent='center'>
                        <Grid item>
                            <Button variant='contained' size='small' href={href1} sx={styles.heroButton}>{button1}</Button>
                        </Grid>
                        { button2 && (
                            <Grid item>
                                <Button variant='outlined' color='secondary' size='small' href={href2} sx={styles.heroOutlineButton}>{button2}</Button>
                            </Grid>
                        )}
                    </Grid>
                )}
            </div>
        </div>
    )
}

export default HeroNew;